module.exports = __webpack_public_path__ + "img/guardians-of-the-galaxy.45fe61dc.svg";